import React from 'react';

const Loading = () => {
    return (
        <div className="flex justify-center items-center">
          <div class="w-7 h-7 border-4 border-dashed rounded-full animate-spin border-gray-50"></div>
        </div>
    );
};

export default Loading;